import api, { GetApiReturn, GetApiReturnError, ValidateAxiosError } from '@/modules/api.service';
import axios from 'axios';
import { API_URL } from '@/shared/constants/strings';
import { CreateEstagioEventoDto, ResponseEstagioDto, ResponseEstagioEventoDto } from '@/api.types';
import { Endpoints } from '@/shared/constants/endpoints';
import { getLoginTokenFromStorage } from '@/modules/system/auth/application/auth.service';
import { FindEstagioEventoDto } from '@/api.types.extra';

const endpoint = Endpoints.ESTAGIO;
const endpoint2 = Endpoints.ESTAGIO_EVENTOS;

export async function listarEstagios(idEstagiario: number) {
  return api
    .get(Endpoints.ESTAGIO + '/lista/' + idEstagiario)
    .then((response) => {
      return GetApiReturn<ResponseEstagioDto>(response.data as Array<ResponseEstagioDto>);
    })
    .catch((error) => {
      ValidateAxiosError<ResponseEstagioDto>(error, 'Falha ao listar Estágios.');
      return GetApiReturnError<ResponseEstagioDto>();
    });
}

// Anexos
export async function attachEstagioFile(id: string, formData: FormData) {
  const api2 = axios.create({ baseURL: API_URL });
  api2.interceptors.request.use((config) => {
    config.headers['Content-Type'] = 'multipart/form-data';
    //config.headers['Access-Control-Allow-Origin'] = '*';
    config.headers.Authorization = `Bearer ${getLoginTokenFromStorage()}`;
    return config;
  });

  await api2
    .post(endpoint + '/' + id + '/file', formData)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      console.warn(error);
      return ValidateAxiosError(error, 'Falha ao enviar arquivo.');
    });
}

export async function enumerateEstagioAnexos(idEstagio: number) {
  try {
    const response = await api.get(`${endpoint}/anexos/anexos/${idEstagio}`);
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao buscar anexos do estágio.');
  }
}

export async function downloadEstagioFile(id: number): Promise<{ arquivo: ArrayBuffer; filename: string }> {
  try {
    const response = await api.get(`${endpoint}/file/${id}`);
    const data = response.data;

    let arquivo: ArrayBuffer;

    // O NestJS serializa Buffer como base64 string quando retorna JSON
    if (typeof data.arquivo === 'string') {
      // Base64 para ArrayBuffer
      const binaryString = atob(data.arquivo);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      arquivo = bytes.buffer;
    } else if (data.arquivo?.data) {
      // Se vier como objeto Buffer com propriedade data (array de números)
      const buffer = new Uint8Array(data.arquivo.data);
      arquivo = buffer.buffer;
    } else if (data.arquivo instanceof ArrayBuffer) {
      arquivo = data.arquivo;
    } else {
      // Fallback: tentar converter qualquer formato
      const buffer = new Uint8Array(Object.values(data.arquivo || []));
      arquivo = buffer.buffer;
    }

    return {
      arquivo,
      filename: data.filename
    };
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao baixar o arquivo.');
  }
}

export async function deleteEstagioFile(id: number) {
  try {
    const response = await api.delete(`${endpoint}/file/${id}`);
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao remover o anexo.');
  }
}

export async function listarEventosEstagio(params: FindEstagioEventoDto): Promise<ResponseEstagioEventoDto[]> {
  try {
    const response = await api.get(`${endpoint2}`, { params: params });
    return response.data[0] || [];
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao listar eventos do estágio.');
  }
}

export async function criarEventoEstagio(dto: CreateEstagioEventoDto): Promise<number> {
  try {
    const response = await api.post(`${endpoint2}`, dto);
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao criar evento de estágio.');
  }
}

export async function atualizarEventoEstagio(id: number, dto: Partial<CreateEstagioEventoDto>): Promise<void> {
  try {
    await api.put(`${endpoint2}/${id}`, dto);
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao atualizar evento de estágio.');
  }
}

export async function excluirEventoEstagio(id: number): Promise<void> {
  try {
    await api.delete(`${endpoint2}/${id}`);
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao excluir evento de estágio.');
  }
}